import React from "react";
import { IconColor } from "../interface/ColorInterface";

export const TestimonialIconSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform={transform}
  >
    <path
      d="M12 2C6.48 2 2 5.82 2 10.5C2 13.54 4.08 16.09 7 17.45V22L11.07 19.43C11.37 19.47 11.68 19.5 12 19.5C17.52 19.5 22 15.68 22 11C22 6.32 17.52 2 12 2Z"
      fill={color || "white"}
    />
  </svg>
);
